//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: ''
    },

    customBg: {
      type: String,
      default: ''
    },

    breadcrumbs: {
      type: Array,
      default: () => {
        return []
      }
    },

    backButton: {
      type: Boolean,
      default: true
    }
  }
}
